const wtwWhiteListedDomains =
  (
    import.meta.env.VITE_APP_WTW_LOGINPAGE_WHITELISTED_DOMAINS?.split(',') || []
  ).map((domain: string) => domain.trim()) || [];

export const wtwLoginPageExceptionMessage =
  'Username and password aren’t required for your account. Use the link in your “Welcome to Tradeflow” email to access the platform directly.';
export const canWTWUserUseLoginPage = (
  userNameInput: string | undefined,
  isWTW: boolean,
) => {
  if (!isWTW) {
    return true;
  }

  return (
    userNameInput &&
    wtwWhiteListedDomains.some((domain: string) =>
      userNameInput.toLowerCase().includes(domain.toLowerCase()),
    )
  );
};
